/*eslint-disable*/ export const messages = JSON.parse("{\"radio-group.label.optional\":[\"Valfritt\"],\"radio-group.validation.required\":[\"Välj ett alternativ.\"]}");
//# sourceMappingURL=messages.mjs.map